import React, { memo } from "react"
import { Grid } from "semantic-ui-react"
import { formatCurrency } from "uikit"
import "./AccountStatistics.css"

export const AccountStatistics = memo(({ accounts, properties }) => {
  if (!accounts && !properties) {
    return null
  }
  const combinedMonetaryValues = accounts
    .filter(({ is_confirmed }) => is_confirmed)
    .map(account => account.balance)
    .concat(properties.map(property => property.value))
  const totalDebts = Math.abs(
    combinedMonetaryValues
      .filter(value => value < 0)
      .reduce((prev, curr) => Number(prev) + Number(curr), 0)
  )
  const totalAssets = combinedMonetaryValues
    .filter(value => value > 0)
    .reduce((prev, curr) => Number(prev) + Number(curr), 0)
  const netAssets = totalAssets - totalDebts
  return (
    <Grid stackable className="AccountStatistics__Grid">
      <Grid.Row columns={2} className="Accounts__Statistics_Row">
        <Grid.Column width={6} className="Accounts__Statistics_Row_FirstColumn">
          <Grid>
            <Grid.Row
              centered
              columns={1}
              className="Accounts__Statistics_Row_SummaryRow"
            >
              <Grid.Column
                textAlign="center"
                className="Accounts__Statistics__TotalAssets"
              >
                <h3 className="Accounts__Statistics__TotalAssets_Figure">
                  {formatCurrency(totalAssets)}
                </h3>
                <h5 className="Accounts__Statistics_FigureLabel">
                  TOTAL ASSETS
                </h5>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={1}>
              <Grid.Column
                textAlign="center"
                className="Accounts__Statistics__Debts"
              >
                <h3 className="Accounts__Statistics__Debts_Figure">
                  {formatCurrency(totalDebts)}
                </h3>
                <h5 className="Accounts__Statistics_FigureLabel">
                  TOTAL DEBTS
                </h5>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Grid.Column>
        <Grid.Column verticalAlign="middle" textAlign="center" width={10}>
          <h1 className="Accounts__Statistics__NetWorth">
            {formatCurrency(netAssets)}
          </h1>
          <h5 className="Accounts__Statistics_FigureLabel">NET WORTH</h5>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
})
